var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":true,"fullscreen":true,"close-on-click-modal":false,"before-close":_vm.handleClose}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-form',{ref:"declutterReportForm",attrs:{"label-position":"top","model":_vm.declutterReport,"rules":_vm.rules}},[(_vm.declutterReportId)?_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Év","prop":"year"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.year),callback:function ($$v) {_vm.$set(_vm.declutterReport, "year", $$v)},expression:"declutterReport.year"}})],1)],1),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Sorszám","prop":"number"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.number),callback:function ($$v) {_vm.$set(_vm.declutterReport, "number", $$v)},expression:"declutterReport.number"}})],1)],1)],1):_vm._e(),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"receipts","label":"Bizonylatok"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"month","value-format":"yyyy-MM","clearable":false,"disabled":_vm.declutterReport.status !== 'recorded' || _vm.type === 'view',"placeholder":"Válasszon évet és hónapot..."},on:{"change":_vm.fetchItemsByMonth},model:{value:(_vm.declutterReport.filtered_date),callback:function ($$v) {_vm.$set(_vm.declutterReport, "filtered_date", $$v)},expression:"declutterReport.filtered_date"}})],1)],1),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"delivery_date","label":"Kiállítás dátuma"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","clearable":false,"format":"yyyy. MM. dd.","value-format":"yyyy-MM-dd","picker-options":_vm.deliveryDateOption,"disabled":_vm.declutterReport.status !== 'recorded' || _vm.type === 'view'},model:{value:(_vm.declutterReport.delivery_date),callback:function ($$v) {_vm.$set(_vm.declutterReport, "delivery_date", $$v)},expression:"declutterReport.delivery_date"}})],1)],1)],1),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"company_name","label":"Cégnév"}},[_c('el-input',{attrs:{"readonly":"","disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.company_name),callback:function ($$v) {_vm.$set(_vm.declutterReport, "company_name", $$v)},expression:"declutterReport.company_name"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"postal_code","label":"Irányítószám"}},[_c('el-input',{attrs:{"readonly":"","disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.postal_code),callback:function ($$v) {_vm.$set(_vm.declutterReport, "postal_code", $$v)},expression:"declutterReport.postal_code"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"city","label":"Település"}},[_c('el-input',{attrs:{"readonly":"","disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.city),callback:function ($$v) {_vm.$set(_vm.declutterReport, "city", $$v)},expression:"declutterReport.city"}})],1)],1),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"prop":"address","label":"Cím"}},[_c('el-input',{attrs:{"readonly":"","disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.address),callback:function ($$v) {_vm.$set(_vm.declutterReport, "address", $$v)},expression:"declutterReport.address"}})],1)],1)],1),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"contributors","label":"Résztvevők a selejtezési bizottság részéről"}},[_c('p-table',{key:_vm.itemsTableKey + 'c',ref:"contributors",attrs:{"opts":{
                addItem: true,
                updateItem: true,
                deleteItem: true,
                editableFields: [],
              },"dialog":"PersonDialog","columns":[
                {
                  label: 'Név',
                  prop: 'name',
                  minWidth: 100,
                },
                {
                  label: 'Beosztás',
                  prop: 'role',
                } ],"data":_vm.declutterReport.contributors,"empty-line":{
                name: '',
                role: '',
              }}})],1)],1),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"supervision_contributors","label":"Résztvevők a felügyeleti (érdekképviseleti) szerv részéről"}},[_c('p-table',{key:_vm.itemsTableKey + 'sc',ref:"supervisionContributors",attrs:{"opts":{
                addItem: true,
                updateItem: true,
                deleteItem: true,
                editableFields: [],
              },"dialog":"PersonDialog","columns":[
                {
                  label: 'Név',
                  prop: 'name',
                  minWidth: 100,
                },
                {
                  label: 'Beosztás',
                  prop: 'role',
                } ],"data":_vm.declutterReport.supervision_contributors,"empty-line":{
                name: '',
                role: '',
              }}})],1)],1),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"task_contributors","label":"Szükséges intézkedésekért felelős dolgozó(k) kijelölése"}},[_c('p-table',{key:_vm.itemsTableKey + 'tc',ref:"taskContributors",attrs:{"opts":{
                addItem: true,
                updateItem: true,
                deleteItem: true,
                editableFields: [],
              },"dialog":"PersonTaskDialog","columns":[
                {
                  label: 'Intézkedés',
                  prop: 'task',
                  minWidth: 100,
                },
                {
                  label: 'Név',
                  prop: 'name',
                  minWidth: 100,
                },
                {
                  label: 'Beosztás',
                  prop: 'role',
                } ],"data":_vm.declutterReport.task_contributors,"empty-line":{
                task: '',
                name: '',
                role: '',
              }}})],1)],1)],1),_c('el-form-item',{attrs:{"prop":"comment","label":"Gondatlanság vagy egyéb mulasztás miatti megállapítások és javaslatok"}},[_c('el-input',{attrs:{"type":"textarea","rows":3,"disabled":_vm.type === 'view'},model:{value:(_vm.declutterReport.comment),callback:function ($$v) {_vm.$set(_vm.declutterReport, "comment", $$v)},expression:"declutterReport.comment"}})],1),_c('el-form-item',{attrs:{"prop":"items","label":"Tételek"}},[_c('p-table',{key:_vm.itemsTableKey,ref:"items",attrs:{"opts":{
            addItem: false,
            updateItem: true,
            deleteItem: true,
            editableFields: [],
          },"dialog":"PriceDialog","columns":[
            {
              label: 'Selejtezés',
              prop: 'declutter_receipt_number',
              minWidth: 100,
            },
            {
              label: 'Beszállító',
              prop: 'supplier_name',
              minWidth: 100,
            },
            {
              label: 'Termék',
              prop: 'name',
              minWidth: 100,
            },
            {
              label: 'Selejtezés oka',
              prop: 'declutter_reason',
            },
            {
              label: 'Mennyiség',
              prop: 'count',
              minWidth: 100,
            },
            {
              label: 'Db / kiszerelés',
              prop: 'count_per_pack',
            },
            {
              label: 'Kiszerelés',
              prop: 'pack_type_name',
            },
            {
              label: 'Egységár',
              prop: 'unit_price',
            },
            {
              label: 'Nettó ár',
              prop: 'net_price',
            } ],"data":_vm.declutterReport.items,"empty-line":{
            task: '',
            name: '',
            role: '',
          }},on:{"change":_vm.updateReceipts}})],1)],1)],1),(_vm.type !== 'view')?_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.buttonLoading,"disabled":_vm.declutterReport.status !== 'recorded'},on:{"click":_vm.store}},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n    ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }